import React, { memo } from "react";
import {
  ComposableMap,
  ZoomableGroup,
  Geographies,
  Geography,
  Marker
} from "react-simple-maps";


const geoUrl =
"https://raw.githubusercontent.com/deldersveld/topojson/master/world-countries.json";

const MapChart = ({ title, chartType, datatype, chartData, setTooltipContent }) => {

  if (chartData) {

    return (
      <ComposableMap data-tip="">
        {/* <ZoomableGroup center={[0, 0]}> */}
        <Geographies geography={geoUrl}>
          {({ geographies }) =>
            geographies.map(geography => (
             
              <Geography key={geography.rsmKey} geography={geography} 
              // onMouseEnter={() => {
              //   setTooltipContent(`${geography.properties.name}`);
              // }}
              // onMouseLeave={() => {
              //   setTooltipContent("");
              // }}
              // style={{
              //   default: {
              //     fill: "#D6D6DA",
              //     outline: "none"
              //   },
              //   hover: {
              //     fill: "#F53",
              //     outline: "none"
              //   },
              //   pressed: {
              //     fill: "#E42",
              //     outline: "none"
              //   }
              // }}
              fill="#EAEAEC"
              stroke="#D6D6DA" 
                />
            ))
          }
        </Geographies>
        {chartData.map(({ name, clientname, country, city, region, latitude, longitude }, i) => (
          <Marker
            coordinates={[longitude, latitude]}
            onMouseEnter={() => {
              setTooltipContent(`${name} - ${clientname} - ${country} - ${city} - ${region}`);

            }}
            onMouseLeave={() => {
              setTooltipContent("");
            }}
          >
            <circle
              cx={2}
              cy={2}
              r={5}
              style={{
                stroke: "#FF5722",
                fill: "#FF5722",
                strokeWidth: 0.2,
                opacity: 0.2
              }}
            />
          </Marker>
        ))}

        {/* </ZoomableGroup> */}
      </ComposableMap>
    );
  }
  else
    return (<></>);
};

export default memo(MapChart);
